/**
 * sanitizeLatin1
 * Reemplaza caracteres fuera del rango Latin1 (0-255) para evitar
 * el error "InvalidCharacterError" de btoa().
 *
 * Caracteres con tilde españoles (á, é, í, ó, ú, ñ, ü, etc.) NO se ven
 * afectados porque están dentro de Latin1.
 */

const REPLACEMENTS = {
  '\u20AC': 'EUR',    // € → EUR
  '\u2018': "'",      // ' (comilla simple izquierda)
  '\u2019': "'",      // ' (comilla simple derecha)
  '\u201C': '"',      // " (comilla doble izquierda)
  '\u201D': '"',      // " (comilla doble derecha)
  '\u2013': '-',      // – (guion medio / en-dash)
  '\u2014': '-',      // — (guion largo / em-dash)
  '\u2026': '...',    // … (elipsis)
};

/**
 * Sanitiza un string reemplazando caracteres no-Latin1 por equivalentes seguros.
 * @param {string} str - Texto a sanitizar
 * @returns {string} Texto compatible con btoa() (solo chars 0-255)
 */
export function sanitizeLatin1(str) {
  if (!str) return str;

  let result = '';
  for (let i = 0; i < str.length; i++) {
    const char = str[i];
    const code = char.charCodeAt(0);

    if (code <= 255) {
      // Dentro de Latin1, se deja tal cual
      result += char;
    } else if (REPLACEMENTS[char]) {
      result += REPLACEMENTS[char];
    } else {
      console.warn(
        `[sanitizeLatin1] Carácter no-Latin1 reemplazado por "?": "${char}" (U+${code.toString(16).toUpperCase().padStart(4, '0')})`
      );
      result += '?';
    }
  }

  return result;
}

/**
 * Sanitiza recursivamente todos los strings de un objeto/array.
 * Útil para limpiar opciones completas antes de pasarlas al SDK de WebSign.
 * No modifica el objeto original, devuelve una copia.
 * @param {*} obj - Objeto, array o valor a sanitizar
 * @returns {*} Copia sanitizada
 */
export function sanitizeObjectLatin1(obj) {
  if (obj === null || obj === undefined) return obj;
  if (typeof obj === 'string') return sanitizeLatin1(obj);
  if (Array.isArray(obj)) return obj.map(item => sanitizeObjectLatin1(item));
  if (typeof obj === 'object') {
    const result = {};
    for (const [key, value] of Object.entries(obj)) {
      result[key] = sanitizeObjectLatin1(value);
    }
    return result;
  }
  return obj;
}
